export default function ClientesSinPrestamoFilters({ 
  filters, 
  onChange, 
  onApply, 
  onReset, 
  loading, 
  errors = {}, 
  formError = ''
}) {
  const getErrorMessage = (error) => {
    if (!error) return '';
    return Array.isArray(error) ? error[0] : error;
  };

  const fieldClass = (hasError) =>
    `w-full rounded-2xl border bg-white px-4 py-3 text-sm text-gray-900 shadow-sm transition
     ${hasError 
       ? 'border-red-400 ring-2 ring-red-200 focus:ring-red-300 focus:border-red-400'
       : 'border-gray-200 focus:ring-2 focus:ring-red-200 focus:border-red-300'}`;

  return (
    <section className="space-y-4">
      {/* Error del formulario */}
      {!!formError && (
        <div 
          className="rounded-2xl border border-red-200 bg-red-50 px-4 py-3 text-red-700 text-sm" 
          role="alert" 
          aria-live="polite"
        >
          {formError}
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-end">
        {/* BÚSQUEDA */}
        <div>
          <label 
            htmlFor="search" 
            className="block text-xs font-semibold uppercase tracking-[0.2em] text-gray-500 mb-2"
          >
            BUSCAR CLIENTE
          </label>
          <input
            id="search"
            name="search"
            type="text"
            placeholder="Nombre, apellido o DNI..."
            value={filters.search}
            onChange={onChange}
            className={fieldClass(!!errors.search)}
            aria-invalid={!!errors.search}
            aria-describedby={errors.search ? 'search_error' : undefined}
          />
          <div className="h-5">
            {!!errors.search && (
              <p id="search_error" className="mt-1 text-xs text-red-600">
                {getErrorMessage(errors.search)}
              </p>
            )}
          </div>
        </div>

        {/* ESTADO CLIENTE */}
        <div>
          <label 
            htmlFor="estado_cliente" 
            className="block text-xs font-semibold uppercase tracking-[0.2em] text-gray-500 mb-2"
          >
            ESTADO DEL CLIENTE
          </label>
          <select
            id="estado_cliente"
            name="estado_cliente"
            value={filters.estado_cliente || 'todos'}
            onChange={onChange}
            className={fieldClass(!!errors.estado_cliente)}
            aria-invalid={!!errors.estado_cliente}
            aria-describedby={errors.estado_cliente ? 'estado_cliente_error' : undefined}
          >
            <option value="todos">Todos los clientes</option>
            <option value="sin_prestamo_activo">Con Historial de Préstamos</option>
            <option value="sin_registro_prestamos">Sin Registro de Préstamos</option>
          </select>
          <div className="h-5">
            {!!errors.estado_cliente && (
              <p id="estado_cliente_error" className="mt-1 text-xs text-red-600">
                {getErrorMessage(errors.estado_cliente)}
              </p>
            )}
          </div>
        </div>

        <div className="flex flex-col justify-end">
          <span
            className="block text-xs font-semibold uppercase tracking-[0.2em] text-gray-500 mb-2 opacity-0"
            aria-hidden="true"
          >
            APLICAR
          </span>
          <button
            type="button"
            onClick={onApply}
            disabled={loading}
            aria-busy={loading}
            className="w-full rounded-full bg-red-600 px-6 py-3 text-sm font-semibold text-white shadow-sm transition hover:bg-red-700 hover:shadow-md disabled:cursor-not-allowed disabled:bg-gray-300"
          >
            {loading ? 'Cargando…' : 'Aplicar'}
          </button>
          <div className="h-5" aria-hidden="true" />
        </div>

        <div className="flex flex-col justify-end">
          <span
            className="block text-xs font-semibold uppercase tracking-[0.2em] text-gray-500 mb-2 opacity-0"
            aria-hidden="true"
          >
            LIMPIAR
          </span>
          <button
            type="button"
            onClick={onReset}
            disabled={loading}
            className="w-full rounded-full border border-red-200 bg-white px-6 py-3 text-sm font-semibold text-red-600 shadow-sm transition hover:border-red-300 hover:bg-red-50 disabled:cursor-not-allowed disabled:opacity-70"
          >
            Limpiar
          </button>
          <div className="h-5" aria-hidden="true" />
        </div>
      </div>
    </section>
  );
}
